import { ServiceHealth } from '@/types';
import { Panel, PanelRows } from './Panel';
import { ServiceRow } from './ServiceRow';
import { HistoryStripLegend } from './ServiceHistoryStrip';

interface ServiceListProps {
  services: ServiceHealth[];
  /** True when health could not be read, so every row is Unknown. */
  dataUnavailable?: boolean;
}

export function ServiceList({ services, dataUnavailable }: ServiceListProps) {
  // Position is a status signal in its own right: whatever is broken sits at
  // the top of the list, so the reader never has to scan for it.
  const sortedServices = [...services].sort((a, b) => {
    const priority = { outage: 0, degraded: 1, operational: 2 };
    return priority[a.status] - priority[b.status];
  });

  return (
    <Panel
      title="Services"
      action={
        <span className="text-xs text-slate-500">
          {dataUnavailable ? 'Health unknown' : `${services.length} monitored`}
        </span>
      }
    >
      <PanelRows>
        {sortedServices.map((service) => (
          <ServiceRow
            key={service.name}
            service={service}
            statusUnknown={dataUnavailable}
          />
        ))}
      </PanelRows>
      <div className="border-t border-slate-100 px-4 py-3 sm:px-5">
        <HistoryStripLegend />
        <p className="mt-2 text-[11px] leading-relaxed text-slate-400">
          Someta records failures, not successes, so a quiet bar means nothing
          was reported — a weaker claim than a measured uptime figure, and the
          reason these bars are grey rather than green. Nothing older than 24
          hours is retained, so there is no 90-day history to show.
        </p>
      </div>
    </Panel>
  );
}
